import React, {useState, useEffect} from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
  InputGroup,
  FormGroup,
} from "components/common";
import GetBack from "components/refactoring/BackButton";
import { compose, withState, withHandlers, lifecycle, withPropsOnChange } from "recompose";
import qs from "query-string";
import { LocalForm, Control, actions, Fieldset, track } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import { ApiClient } from "services";
import { NotificationManager } from "react-notifications";
import LoadingMsg from "components/common/LoadingMsg";
import { ColouredLink } from "components/HoverCard";
import ManageFeatures from "./ManageFeatures";

const useSelection = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleToggle = (object_id, contentType) => {
    if (selectedItems.some(item => item.object_id === object_id)) {
      setSelectedItems(selectedItems.filter(item => item.object_id !== object_id));
    } else {
      setSelectedItems([...selectedItems, { object_id, content_type: contentType }]);
    }
  };

  return [selectedItems, handleToggle];
};


export const PlanEdit = ({
  t,
  mode,
  item,
  match,
  renderServerError,
}) => {

  const history = useHistory();

  const client = ApiClient();

  const [modulesData, setmodulesData] = useState();
  const [applicationData, setapplicationData] = useState();
  const [languageData, setlanguageData] = useState();
  const [loading, setLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [show, setisOpen] = useState(false);
  const [featuresList, setFeaturesList] = useState(item?.feature_list || []);

  const updateFeaturesList = (updatedList) => {
    setFeaturesList(updatedList);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)

        const responseM = await client.get("core/hesaab_module");
        const mdata = responseM.data;
        setmodulesData(mdata);
        const responseA = await client.get("core/hesaab_application");
        const adata = responseA.data;
        setapplicationData(adata)
        const responseL = await client.get("core/hesaab_language");
        const ldata = responseL.data;
        setlanguageData(ldata);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };

    fetchData();
  }, []);

  const [selectedLang, handleLanguageToggle] = useSelection();
  const [selectedMod, handleModToggle] = useSelection();
  const [selectedApp, handleAppToggle] = useSelection();

  const noInlusivesFound = modulesData?.length === 0 || languageData?.length === 0  || applicationData?.length === 0

  const dataFound = [
    { condition: modulesData?.length === 0, message: t("No Modules Found") },
    { condition: languageData?.length === 0, message: t("No Languages Found") },
    { condition: applicationData?.length === 0, message: t("No Apps Found") }
  ]

  const allSelectedItems = selectedLang.concat(selectedMod, selectedApp);

  function isNumericString(input) {  
    return typeof input === 'string' && !isNaN(input)
  }

  const isEdit = isNumericString(match.params.id)? true : false

  const getValuesByPattern = (obj, pattern, type) => {
    return Object.entries(obj)
      .filter(([key]) => key.startsWith(pattern))
      .map(([key, value]) => ({ type, id: key.split("-")[1], value }));
  };

  const monthlyList = item?.subscription_prices?.findIndex(item => item.plan_type === 'Monthly');
  const yearlyList = item?.subscription_prices?.findIndex(item => item.plan_type === 'Yearly');

  const handlePost = async (values) => {

    setIsSending(true)

    const { monthly_price, yearly_price, max_bill_limit, max_employee_limit, max_invoice_limit, order, name, subscription_prices, additional_language_limit, active } = values;

    const allItems = [
      ...getValuesByPattern(values, "lang-", "hesaablanguage"),
      ...getValuesByPattern(values, "app-", "hesaabapplication"),
      ...getValuesByPattern(values, "mod-", "hesaabmodule")
    ];

    const trueItems = allItems.filter(item => item.value);

    const allPatchInc = [];
    trueItems.forEach(trueItem => {
      allPatchInc.push({ object_id: trueItem.id, content_type: trueItem.type });
    });

    const createPlan = (plan_type, price, currency) => ({
      currency,
      plan_type,
      price
    });
    
    const monthlyPlan = createPlan("Monthly", monthly_price, "SAR");
    const yearlyPlan = createPlan("Yearly", yearly_price, "SAR");

    const yearlyPlanUpdate = createPlan("Yearly", subscription_prices?.[yearlyList].price, "SAR");
    const monthlyPlanUpdate = createPlan("Monthly", subscription_prices?.[monthlyList].price, "SAR");

    const commonValues = {
      name: name,
      max_employee_limit: max_employee_limit,
      max_invoice_limit: max_invoice_limit,
      max_bill_limit: max_bill_limit,
      order: order,
      additional_language_limit: additional_language_limit,
    };
    
    const postValues = {
      ...commonValues,
      active,
      subscription_plan_inclusives: allSelectedItems,
      subscription_prices: [monthlyPlan, yearlyPlan],
    };
    
    const patchValues = {
      ...commonValues,
      subscription_plan_inclusives: allPatchInc,
      subscription_prices: [monthlyPlanUpdate, yearlyPlanUpdate],
      feature_list: featuresList,
    };
    
    const finalValues = isEdit ? patchValues : postValues

    let endpoint = isEdit ? `/${match.params.id}` : ''
    let method = isEdit ? "put" : "post"
    
    client[method](`/subscription-plans${endpoint}`, finalValues)
      .then(response => {
        if (method === 'post') { 
          NotificationManager.success(t('Subscription Plan Added Successfully.'));
          setIsSending(false);
          setTimeout(() => {
            history.push("/subscription/plan");
          }, 1500);
        } else { 
          NotificationManager.success(t('Subscription Plan Updated Successfully.'));
          setIsSending(false);
          setTimeout(() => {
            history.push(`/subscription/plan`);
          }, 1500);
        }
        return true;
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const errorMessage = `${key.charAt(0).toUpperCase() + key.slice(1)} - ${value}`;
            NotificationManager.error(errorMessage);
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
};

const linkClick = (name) => {
  history.push(`/core/${name}/new`)
}

  return (
    <Page title={`${mode} Subscription plan`}>
      <GetBack styleClass="my-2"/>
      {loading ? <LoadingMsg/> : 
      <>
      {noInlusivesFound ? 
      <div className="text-center" style={{fontSize: "1.3em"}}>
        <p>
          <Trans>Please Create <ColouredLink onClick={() => linkClick("modules")}>Module</ColouredLink>, <ColouredLink onClick={() => linkClick("app")}>Application</ColouredLink> and <ColouredLink onClick={() => linkClick("language")}>Language</ColouredLink> To Create A Subscription Plan</Trans>
        </p>
        <div className="form-text text-muted small">
          {dataFound?.map(({ condition, message }, index, array) => (
            <>
              {condition && <span>{message}</span>}
              {condition && index < array.length - 1 && array[index + 1].condition && array[index + 1].message && " || "}
            </>
          ))}
        </div>
      </div>
      : 
      <LocalForm initialState={item} onSubmit={values => handlePost(values)}>
        <span className="d-print-none card-title">General Info</span>
        {match.params.id !== "new" && <Button className="float-right" onClick={() => setisOpen(true)}><Trans>Manage Plan Features</Trans></Button>}
        <hr/>
        <FormGroup label="Name *" model=".name">
          <Control.text model=".name" placeholder="A descriptive name for this subscription." />
        </FormGroup>
        <Row>
            <Col md="6" xs={false}>
                <FormGroup label="Max invoice limit *" model=".max_invoice_limit">
                <Control.text model=".max_invoice_limit" placeholder="" />
                </FormGroup>
                <FormGroup label="Max bill limit *" model=".max_bill_limit">
                <Control.text model=".max_bill_limit" placeholder="" />
                </FormGroup>
            </Col>
            <Col md="6" xs={false}>
                <FormGroup label="Max employee limit" model=".max_employee_limit">
                <Control.text model=".max_employee_limit" placeholder="" />
                </FormGroup>
                <FormGroup label="Order" model=".order">
                <Control.text model=".order" placeholder={t("Order of the Plan")} />
                </FormGroup>
            </Col>
        </Row>
        
        <div className="my-3">
          <span><Control.checkbox model=".active" defaultValue={true} /> <Trans>Activate Plan</Trans></span>
        </div>

        <span className="d-print-none card-title">Packages Info</span>
        <hr></hr>
        <Row>
            <Col md="4" xs={false}>
                <span className="d-print-none card-title">Modules</span>
                <table className="table table-sm border" style={{maxWidth:"100%"}}>
                <thead>
                <tr>
                    <th className="text-left"><Trans>Name</Trans></th>
                    <th className="text-right"><Trans>Select</Trans></th>
                </tr>
                </thead>
                <tbody>
                {modulesData?.map((i) => (
                    <tr key={i.id}>
                        <td className="text-left">{i.name}</td>  
                        <td className="text-right">
                        <Control.checkbox
                          model={`.mod-${i.id}`}
                          checked={selectedMod.includes(i.id)}
                          onChange={() => handleModToggle(i.id, i.content_type)}
                          defaultValue={item?.subscription_plan_inclusives?.some(inclusive => inclusive.content_type === i.content_type && inclusive.object_id === i.id) || false}
                        />
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            </Col>
            <Col md="4" xs={false}>
                <span className="d-print-none card-title">Applications</span>
                <table className="table table-sm border" style={{maxWidth:"100%"}}>
                <thead>
                <tr>
                    <th className="text-left"><Trans>Name</Trans></th>
                    <th className="text-right"><Trans>Select</Trans></th>
                </tr>
                </thead>
                <tbody>
                {applicationData?.map((i) => (
                    <tr key={i.id}>
                        <td className="text-left">{i.name}</td>
                        <td className="text-right">
                        <Control.checkbox
                          model={`.app-${i.id}`}
                          checked={selectedApp.includes(i.id)}
                          onChange={() => handleAppToggle(i.id, i.content_type)}
                          defaultValue={item?.subscription_plan_inclusives?.some(inclusive => inclusive.content_type === i.content_type && inclusive.object_id === i.id) || false}
                        />
                        </td>
                    </tr>
                ))}
                </tbody>
            </table> 
            </Col>
            <Col md="4" xs={false}>
              <span className="d-print-none card-title">Languages</span>
                <table className="table table-sm border" style={{maxWidth:"100%"}}>
                  <thead>
                  <tr>
                      <th className="text-left"><Trans>Name</Trans></th>
                      <th className="text-right"><Trans>Select</Trans></th>
                  </tr>
                  </thead>
                  <tbody>
                  {languageData?.map((i) => (
                      <tr key={i.id}>
                          <td className="text-left">{i.name}</td>  
                          <td className="text-right">
                          <Control.checkbox
                            model={`.lang-${i.id}`}
                            checked={selectedLang.includes(i.id)}
                            onChange={() => handleLanguageToggle(i.id, i.content_type)}
                            defaultValue={item?.subscription_plan_inclusives?.some(inclusive => inclusive.content_type === i.content_type && inclusive.object_id === i.id) || false}
                          
                          />
                          </td>
                      </tr>
                  ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="2">
                          <FormGroup label="Number of Additional Languages" model=".additional_language_limit">
                            <Control.text model=".additional_language_limit" placeholder="Number of Additional Languages" />
                          </FormGroup>
                      </td>
                    </tr>
                  </tfoot>
              </table>
            </Col>
        </Row>
        <ManageFeatures t={t} updateFeaturesList={updateFeaturesList} item={item} featuresList={featuresList} show={show} setisOpen={setisOpen}/>
        <span className="d-print-none card-title">Price Info</span>
        <hr></hr>
        {!isEdit ? 
        <Row>
          <Col md="6" xs={false}>
          <FormGroup label="Monthly Price">
            <InputGroup suffixText="SAR">
              <Control.text
                maxLength="10"
                model='.monthly_price'
                placeholder={t("Price")}
              />
            </InputGroup>
          </FormGroup>
          </Col>
          <Col md="6" xs={false}>
          <FormGroup label="Yearly Price">
          <InputGroup suffixText="SAR">
            <Control.text
              maxLength="10"
              model='.yearly_price'
              placeholder={t("Price")}
            />
          </InputGroup>
          </FormGroup>
          </Col>
        </Row>:
        <Row>
        <Col md="6" xs={false}>
        <FormGroup label="Monthly Price">
          <InputGroup suffixText="SAR">
            <Control.text
            maxLength="10"
            model={`.subscription_prices[${monthlyList}].price`}
            placeholder={t("Price")}
          />
          </InputGroup>
        </FormGroup>
        </Col>
        <Col md="6" xs={false}>
        <FormGroup label="Yearly Price">
        <InputGroup suffixText="SAR">
          <Control.text
            maxLength="10"
            model={`.subscription_prices[${yearlyList}].price`}
            placeholder={t("Price")}
          />
        </InputGroup>
        </FormGroup>
        </Col>
      </Row>}

        {renderServerError("name")}
        
        <FormGroup className="my-3 d-flex justify-content-end">
          {!isSending? <Button className="px-3 m-0">Save</Button> : <Button className="px-3 m-0" disabled> Saving</Button> }
        </FormGroup>
      </LocalForm>}
      </>
      }
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "subscription-plans",
    defaultItem: { name: "", active: true, },
  }),
  withState("serverErrors", "setServerErrors", {}),
  withState("redirectUrl", "setRedirectUrl", null),
  withHandlers({
  }),
  lifecycle({
    componentDidMount() {
      Promise.resolve().then(() => {
        const q = qs.parse(this.props.location.search);
        if (q.oauth_verifier && q.oauth_token && q.org)
          this.props.verify(q.oauth_token, q.oauth_verifier, q.org);
      });
    },
  })
);

export default enhance(PlanEdit);
